import type { Opt } from '@jet/environment/types/optional';
import type { Logger, LoggerFactory } from '@amp/web-apps-logger';
import type { Bag as NativeBag } from '@jet/environment';
import {
    DEFAULT_STOREFRONT_CODE,
    DEFAULT_LANGUAGE_BCP47,
} from '~/constants/storefront';

export class Bag implements NativeBag {
    private readonly log: Logger;
    private storefront?: string;
    private languageTag?: string;

    static build(loggerFactory: LoggerFactory): Bag {
        return new Bag(loggerFactory.loggerFor('Bag'));
    }

    constructor(log: Logger) {
        this.log = log;
    }

    registerBagKeys(keys: any): void {
        // We hardcode, so registration is a no-op
    }

    double(key: string): number {
        throw new Error(`unrecognized bag double ${key}`);
    }

    integer(key: string): number {
        throw new Error(`unrecognized bag integer ${key}`);
    }

    boolean(key: string): boolean {
        throw new Error(`unrecognized bag boolean ${key}`);
    }

    array(key: string): any[] {
        throw new Error(`unrecognized bag array ${key}`);
    }

    dictionary(key: string): any {
        switch (key) {
            case 'metrics':
                return {};

            default:
                throw new Error(`unrecognized bag dictionary ${key}`);
        }
    }

    url(key: string): string {
        switch (key) {
            default:
                throw new Error(`unrecognized bag url ${key}`);
        }
    }

    string(key: string): Opt<string> {
        switch (key) {
            case 'countryCode':
                if (!this.storefront) {
                    this.log.warn('countryCode was accessed before being set');
                    return DEFAULT_STOREFRONT_CODE;
                }

                return this.storefront;

            case 'language-tag':
                if (!this.languageTag) {
                    this.log.warn('language-tag was accessed before being set');
                    return DEFAULT_LANGUAGE_BCP47;
                }

                return this.languageTag;

            default:
                this.log.warn(`unrecognized bag string ${key}`);
        }
    }

    setLocale(storefront: string, language: string) {
        this.storefront = storefront;
        this.languageTag = language;
    }

    withDifferentLocale(storefront: string, language: string): Bag {
        const bag = new Bag(this.log);
        bag.setLocale(storefront, language);
        return bag;
    }
}
